import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';
import { Basics } from '../../../components/HelpContent/Basics';
import NotesWrapper from '../../../components/NotesLayout/NotesLayout';
import { SlateEditorWrapper } from '../../../components/SlateEditor/SlateEditorWrapper';
import { LoadingSpinner } from '../../../components/StatusUI/LoadingSpinner';
import { usePaginatedQuery } from '../../../utils/DataFetchers';
import Dashboard from '../dashboard';
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 15px;\n  border: 1px solid black;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  padding: 10%;\n  padding-top: 40px;\n  padding-bottom: 20vh;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Editor() {
    var router = useRouter();
    var slug = router.query.slug || [];
    var id = null;
    var highlight = null;
    if (slug.length > 0) id = slug[0];
    if (slug.length > 1) highlight = slug[0]; // const {
    //   data: notes,
    //   status: notesStatus,
    //   isFetching,
    // } = useFetcher<INotesByTagsQuery>('NotesByTags', {
    //   tags: [],
    //   public: false,
    //   creation_date: new Date(),
    // });
    var ref = usePaginatedQuery([
        'NotesByTags',
        {
            tags: [],
            public: false,
            creation_date: null,
            author: null,
            limit: null
        }
    ], {
        paginateOn: 'creation_date'
    }), notes = ref.data, isFetching = ref.isFetching; // const isFetching = false;
    // const notes = [];
    if (!id) {
        if ((notes === null || notes === void 0 ? void 0 : notes.pages[0]) && notes.pages[0].length === 0) {
            // the user is new, has no notes. give them the help page
            return(/*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        children: "Welcome to exegesis!"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "Here is a tutorial to get you started.",
                            ' ',
                            /*#__PURE__*/ _jsxs("b", {
                                children: [
                                    "You can always access this from the ",
                                    "'",
                                    "help",
                                    "'",
                                    " button (the question mark icon) in the top left."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(BasicsWrapper, {
                        children: /*#__PURE__*/ _jsx(Basics, {})
                    })
                ]
            }));
        } else if (id === null) {
            return(/*#__PURE__*/ _jsx(Dashboard, {}));
        } else {
            return(/*#__PURE__*/ _jsx(Wrapper, {
                children: /*#__PURE__*/ _jsx(LoadingSpinner, {
                    width: 50,
                    style: {
                        marginTop: 'calc(50vh - 50px - 40px)'
                    }
                })
            }));
        }
    }
    return(/*#__PURE__*/ _jsx(SlateEditorWrapper, {
        noteId: id
    }));
}
var BasicsWrapper = styled.div(_templateObject());
export var Wrapper = styled.div(_templateObject1());
Editor.layout = NotesWrapper;
export default Editor;
